<template>
    <div class="rencent-sold template4">
        <h3 class="title mg-title">{{ title }}</h3>
        <template v-if="!isMobileSize">
            <HouseBriefList
                :houses="listings"
                :isInMap="true"
            />
        </template>
        <template v-else>
            <HouseGrid
                :houses="listings"
                :class="{ small: false, 'full-screen': true }"
                :showCheckbox="false"
                :isInMap="false"
            />
        </template>
        <div class="btn" v-if="count > 3">
            <a :href="snapshotLink" class="url" rel="noopener noreferrer">{{
                $t('md-search-result.soldListingsForLast', { count })
            }}</a>
        </div>
    </div>
</template>

<script>
import common from '../../recent-sold';
import { getAsyComponent } from '@/common/utils/load-module.js';

export default {
    mixins: [common],
    components: {
        HouseBriefList: getAsyComponent(() =>
            import(
                /* webpackChunkName: "modules/md-house/list-v3_brief-list"*/ '@/modules/md-house/list-v3/brief-list/index.vue'
            )),
        HouseGrid: getAsyComponent(() =>
            import(
                /* webpackChunkName: "modules/md-house/grid-v3_grid"*/ '@/modules/md-house/grid-v3/grid.vue'
            ))
    }
};
</script>

<style lang="scss">
@import '../../../../theme/media.scss';

.rencent-sold.template4 {
    margin-top: 10px;
    h3.title {
        font-family: var(--font-bold);
        font-size: 18px;
        font-weight: 900;
        color: #4a4a60;
        margin: 0;
        margin-bottom: 12px;
        line-height: 30px;
        text-align: left;
        padding-bottom: 0;
        white-space: pre-wrap;
    }
    .md-house.brief-list {
        .house-detail {
            border-bottom-color: #d6dae8;
            .house-price,
            .house-basic,
            .house-address {
                color: #4a4a60;
            }
        }
        .brief-house-list:hover {
            .house-detail {
                .house-price,
                .house-basic,
                .house-address {
                    color: #f5f6fa;
                }
            }
            &.template4:hover {
                background: #f5f6fa;
                .house-detail {
                    .house-price,
                    .house-basic,
                    .house-address {
                        color: #4a4a60;
                    }
                }
            }
        }
    }
    .btn {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 24px;
        margin-bottom: 70px;
        @include media-800 {
            padding: 0 25px;
        }
        .url {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 420px;
            height: 40px;
            background-color: #4c84ff;
            color: #fff;
            @include media-800 {
                width: 100%;
                border: solid 2px #00c8ff;
                color: #00c8ff;
                background-color: #fff;
            }
        }
    }

    .house-list.brief-list.template4 {
        padding-left: 0;
    }
}
</style>
